/* RESPONSIBLE TEAM: team-ai-insights */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type Transition from '@ember/routing/transition';

export default class GetStartedRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare permissionsService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  analytics = {
    section: 'automation',
    place: 'get-started',
  };

  routeWhenNotOptedIn = 'apps.app.automation.fin-ai-agent.analyze.ai-insights';

  get titleToken() {
    return this.intl.t('ai-agent.analyze.get-started');
  }

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeFinReadiness && !this.appService.app.canSeeGenericFinReadiness) {
      this.router.transitionTo(this.routeWhenNotOptedIn);
      return;
    }
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
    await taskFor(this.reportingMetrics.setup).perform();
  }

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: 'fin_readiness_page',
      place: 'get-started',
      section: 'automation',
      is_personalized: this.appService.app.canSeeFinReadiness,
    });
  }
}
